/**
 * Controlled content topic vocabulary — discovery / FAQ grounding.
 *
 * Pillar + contentFormat remain scheduler-mix fields. Topics are the labels
 * operators and the public site should stack on.
 */

import { CONTENT_TOPICS, type ContentTopic } from "./schema";

/** Soft cap so Auto-tag and UI keep posts clustered, not unique. */
export const CONTENT_TOPIC_MAX = 3;

export const CONTENT_TOPIC_LABELS: Record<ContentTopic, string> = {
  "eb5-basics": "EB-5 basics",
  "investment-amount": "Investment amount",
  "tea-rural": "Rural TEA",
  "tea-high-unemployment": "High-unemployment TEA",
  "set-asides": "Set-aside visas",
  "regional-centers": "Regional centers",
  "direct-eb5": "Direct EB-5",
  "source-of-funds": "Source of funds",
  "job-creation": "Job creation",
  "processing-times": "Processing times",
  "visa-backlogs": "China / India backlog",
  "family-dependents": "Family & dependents",
  "green-card-path": "Green card path",
  "after-approval": "After approval",
  "natural-gas-lng": "Natural gas / LNG",
  "oil-gas-operations": "Oil & gas operations",
  "energy-finance": "Energy finance",
  "project-economics": "Project economics",
  "how-veras-works": "How Veras works",
  team: "Team",
};

/**
 * Static FAQ category each topic can ground later
 * (`server/routes/static-data.ts` faqCategories).
 */
export const CONTENT_TOPIC_FAQ_CATEGORY: Partial<Record<ContentTopic, string>> =
  {
    "eb5-basics": "Getting Started",
    "investment-amount": "Investment Requirements",
    "tea-rural": "Set-Aside Categories",
    "tea-high-unemployment": "Set-Aside Categories",
    "set-asides": "Set-Aside Categories",
    "regional-centers": "Regional Centers",
    "direct-eb5": "Direct Investment",
    "source-of-funds": "Source of Funds",
    "job-creation": "Job Creation",
    "processing-times": "Processing Times",
    "visa-backlogs": "Processing Times",
    "family-dependents": "Family & Dependents",
    "green-card-path": "Getting Started",
    "after-approval": "After Approval",
  };

const TOPIC_SET = new Set<string>(CONTENT_TOPICS);

export function isContentTopic(value: string): value is ContentTopic {
  return TOPIC_SET.has(value);
}

/** Drop unknown values, dedupe, cap at CONTENT_TOPIC_MAX. */
export function normalizeContentTopicTags(raw: unknown): ContentTopic[] {
  if (!Array.isArray(raw)) return [];
  const out: ContentTopic[] = [];
  for (const entry of raw) {
    if (typeof entry !== "string") continue;
    const trimmed = entry.trim();
    if (!isContentTopic(trimmed)) continue;
    if (out.includes(trimmed)) continue;
    out.push(trimmed);
    if (out.length >= CONTENT_TOPIC_MAX) break;
  }
  return out;
}
